import httpService from '@/utils/request'
import { contextPath } from '@/config/'

export const getList = (params) => {
  return httpService({
    url: contextPath + '/page-template/list',
    method: 'get',
    params
  })
}

export const createItem = (data) => {
  return httpService({
    url: contextPath + '/page-template/item',
    method: 'post',
    data
  })
}

export const updateItem = (data) => {
  return httpService({
    url: contextPath + '/page-template/item',
    method: 'put',
    data
  })
}

export const queryItem = (params) => {
  return httpService({
    url: contextPath + '/page-template/item',
    method: 'get',
    params
  })
}

export const updateStatus = (params) => {
  return httpService({
    url: contextPath + '/page-template/updateStatus',
    method: 'put',
    params
  })
}
